import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum PrepreparedQueryAction {
  SEARCH = 'search'
}

export class PrepreparedQuery extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_preprepared_query', isEnabled);
  }

  public search(solrQuery: string) {
    this.event(PrepreparedQueryAction.SEARCH, solrQuery);
  }
}
